import { CoverageWithMeta } from '../Coverage.type';

export const findAffected = (
  triggerCode: string,
  coverages: CoverageWithMeta[],
): CoverageWithMeta[] => coverages.filter((coverage) => coverage.triggeredBy?.includes(triggerCode));

export const getCoverageByCode = (
  coverageCode: string,
  coverages: CoverageWithMeta[],
): CoverageWithMeta | undefined => coverages.find((coverage) => coverage.codeIdentifier === coverageCode);

export const isCoverageWithMeta = (
  item: CoverageWithMeta | undefined,
): item is CoverageWithMeta => !!item;

export const findIncluded = (
  parent: CoverageWithMeta | undefined,
  coverages: CoverageWithMeta[],
): CoverageWithMeta[] | undefined => parent?.includesCodes
  ?.map((code) => getCoverageByCode(code, coverages))
  .filter(isCoverageWithMeta);
